// src/pages/EVMA.js

import React from 'react';
import TopBar from '../components/TopBar';
import PowerBIEmbed from '../components/PowerBIEmbed';

const EVMA = ({ userClaims }) => {
  return (
    <div className="min-h-screen bg-gray-100">
      <TopBar currentPage="evma" userClaims={userClaims} />
      
      <div className="p-4">
        <div className="bg-white shadow-md rounded-lg p-4">
          <h2 className="text-xl font-bold text-gray-800 mb-4">EVMA Dashboard</h2>
          <PowerBIEmbed reportId="4376d6c0-6a5e-4f47-938b-6dcabbfa1a98" 
          workspaceId="7d441575-4aa9-4260-99dd-543f002c0340" 
          pageName="Main"
          showPageNavigator
          height={800} />
        </div>
      </div>
    </div>
  );
};

export default EVMA; 